import { LineReveal, Reveal } from "./Motion";
import { testimonials } from "../data/projects";

const initials = (n) => n.split(" ").map((p) => p[0]).join("");

const Quote = ({ t, i }) => (
  <Reveal delay={i * 0.1}>
    <figure className="border-t border-ink pt-8 md:pt-10" data-testid={`testimonial-${i}`}>
      <span className="block h-10 font-serif text-7xl leading-none text-ink md:h-12 md:text-8xl" aria-hidden>“</span>
      <blockquote className="mt-2 font-serif text-2xl italic leading-snug text-ink md:text-4xl">{t.pull}</blockquote>
      {t.body.length > 0 && (
        <div className="mt-8 space-y-4 text-base leading-relaxed text-muted">
          {t.body.map((p) => <p key={p.slice(0, 20)}>{p}</p>)}
        </div>
      )}
      <figcaption className="mt-8 flex items-center gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink font-mono text-xs tracking-[0.1em] text-paper">{initials(t.name)}</span>
        <span>
          <span className="block font-display text-lg font-semibold tracking-[-0.02em] text-ink">{t.name}</span>
          <span className="block text-sm text-muted">{t.role}</span>
          <span className="block font-mono text-[11px] uppercase tracking-[0.14em] text-muted">{t.context}</span>
        </span>
      </figcaption>
    </figure>
  </Reveal>
);

export const Testimonials = () => (
  <section id="testimonials" className="px-5 py-20 md:px-10 md:py-32" data-testid="testimonials-section">
    <div className="mb-12 grid gap-6 md:mb-16 md:grid-cols-12">
      <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted md:col-span-3">(03) Kind words</p>
      <LineReveal as="h2" inView lines={["In their", <em key="e" className="font-serif font-normal italic text-ink">words.</em>]} className="font-display text-5xl font-semibold leading-[0.95] tracking-[-0.05em] text-ink md:col-span-9 md:text-7xl" />
    </div>
    <div className="grid items-start gap-14 md:grid-cols-12 md:gap-10">
      <div className="md:col-span-7"><Quote t={testimonials[0]} i={0} /></div>
      <div className="md:col-span-5 md:pt-40"><Quote t={testimonials[1]} i={1} /></div>
    </div>
  </section>
);
